export const getError = state => state.addCollaborative.get('error')
export const getIsSubmitting = state => state.addCollaborative.get('isSubmitting')
